import React from 'react';

import { Box, CircularProgress } from '@mui/material';

export default function TableLoader() {
  return (
    <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 96 }}>
      <CircularProgress size={32} />
    </Box>
  );
}
